import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { GetQueryClientCustom, QueryProviderCustom } from "@/src/query-client-factory";
import { getCookie } from "@Components/Modules/Helpers";
import { mainContainerId } from "@Constants/PortalConstants";

import App from "./App";

import "./assets.css";

async function initApp() {
    const pageData = window.__Goodie_init;
    pageData.userData.userId = getCookie("userId");

    const queryClient = GetQueryClientCustom(pageData.initialData);

    const render = () => {
        const Comp = (
            <QueryProviderCustom queryClient={queryClient}>
                <BrowserRouter>
                    <App {...pageData} />
                </BrowserRouter>
            </QueryProviderCustom>
        );

        const container = document.getElementById(mainContainerId);
        if (pageData.isClientRender) {
            createRoot(container).render(Comp);
        } else {
            hydrateRoot(container, Comp);
        }
    };

    render();
}

initApp();
